import React from 'react'
import css from './section.module.css'
import {Link} from 'react-router-dom'
import resources from './../../../../resources/index';
import IntegrationCard from './IntegrationCard';
import FreeTrailCard from './FreeTrailCard';
const Section7 = () => {

  const integrationData = [
    {
      status: "Connect",
      status_color: 'rgb(23,92,255)',
      status_bg: 'rgba(23,92,255,.2)',
      icon: resources.images.integration.dimond,
      title: 'Google Drive',
      desc: 'Competently generate unique e-services and client-based models. Globally engage tactical niche',
    },
    {
      status: "Connected",
      status_color: 'rgb(242,87,103)',
      status_bg: 'rgba(242,87,103,.2)',
      icon: resources.images.integration.color_ball,
      title: 'Google Lens',
      desc: ' Globally engage tactical niche markets rather than client-based competently generate services',
    },
  ]
  return (
    <div className={css.section7}>

      <div className={css.first_screen}>

        <div className={css.left}>
          <Link className={`${css.one} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.drive} />
          </Link>
          <Link className={`${css.two} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.google} />
          </Link>
          <Link className={`${css.three} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.snap} />
          </Link>
          <Link className={`${css.four} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.dimond} />
          </Link>
          <Link className={`${css.five} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.figma} />
          </Link>
          <Link className={`${css.six} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.music} />
          </Link>
        </div>

        <div className={css.center}>
          <h4>Integration</h4>
          <h2>We Collaborate with Top Software Company</h2>
          <Link>
          <button>view all integration</button>
          </Link>
        </div>

        <div className={css.right}>
          <Link className={`${css.seven} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.fish} />
          </Link>
          <Link className={`${css.eight} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.ball} />
          </Link>
          <Link className={`${css.nine} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.color_ball} />
          </Link>
          <Link className={`${css.ten} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.line} />
          </Link>
          <Link className={`${css.eleven} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.stair} />
          </Link>
          <Link className={`${css.twelve} ${css.icon}`}>
            <img alt = "Integration" src={resources.images.integration.vs} />
          </Link>
        </div>

      </div>

      <div className={css.second_screen}>
        {integrationData.map((data, index)=>{
          return(
            <IntegrationCard key={index} data = {data} />
          )
        })}
      </div>

      <div className={css.third_screen}>
        <FreeTrailCard />
      </div>

    </div>
  )
}

export default Section7 ;